import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { t } from 'i18next';
import { OnboardingFormFields } from '@Types/index';
import { ControlledTextInput } from './ControlledInputs';

export const emailSchema = z.string().email({ error: () => t('enErrors:email.invalid') });

interface EmailInputProps {
  disabled?: boolean;
  tabIndex: number;
}

export const EmailInput = ({ disabled = false, tabIndex }: EmailInputProps) => {
  const { t: tGlobal } = useTranslation();

  return (
    <ControlledTextInput
      name={OnboardingFormFields.EMAIL}
      title={tGlobal('pages.home.email')}
      id={OnboardingFormFields.EMAIL}
      disabled={disabled}
      tabindex={tabIndex}
    />
  );
};
